// /* eslint-disable arrow-parens */
// import React, { useState, useEffect } from "react";
// import { Modal, Box, Typography, Button, Divider, IconButton, Fade } from "@mui/material";
// import { Grid } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import dateConverterUS from "../../../../../../../utils/date";

// /* Icons as simple SVG components */
// const ShieldIcon = (props: any) => (
// 	<svg
// 		{...props}
// 		width="24"
// 		height="24"
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 	>
// 		<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
// 	</svg>
// );

// const XIcon = (props: any) => (
// 	<svg
// 		{...props}
// 		width="24"
// 		height="24"
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 	>
// 		<line x1="18" y1="6" x2="6" y2="18" />
// 		<line x1="6" y1="6" x2="18" y2="18" />
// 	</svg>
// );

// const CheckCircleIcon = (props: any) => (
// 	<svg
// 		{...props}
// 		width="24"
// 		height="24"
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 	>
// 		<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
// 		<polyline points="22 4 12 14.01 9 11.01" />
// 	</svg>
// );

// const AlertTriangleIcon = (props: any) => (
// 	<svg
// 		{...props}
// 		width="24"
// 		height="24"
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 	>
// 		<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
// 		<line x1="12" y1="9" x2="12" y2="13" />
// 		<line x1="12" y1="17" x2="12.01" y2="17" />
// 	</svg>
// );

// const ArrowRightIcon = (props: any) => (
// 	<svg
// 		{...props}
// 		width="24"
// 		height="24"
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke="currentColor"
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 	>
// 		<line x1="5" y1="12" x2="19" y2="12" />
// 		<polyline points="12 5 19 12 12 19" />
// 	</svg>
// );

// /* Animation */
// const slideIn = keyframes`
//   0% {
//     transform: translate(-50%, -60%);
//     opacity: 0;
//   }
//   100% {
//     transform: translate(-50%, -50%);
//     opacity: 1;
//   }
// `;

// interface IdentityConflictModalProps {
// 	open: boolean;
// 	onClose: () => void;
// 	onConfirm?: () => void;
// 	memberData: any;
// }

// type Step = "conversion" | "success";

// const IdentityPersonConversionExistsModal: React.FC<IdentityConflictModalProps> = ({
// 	open,
// 	onClose,
// 	onConfirm,
// 	memberData
// }) => {
// 	const { first_name, last_name, date_of_birth, role, relationship, alt_id } = memberData || {};

// 	const [step, setStep] = useState<Step>("conversion");
// 	const [isConverting, setIsConverting] = useState(false);

// 	const isEmployee = role === "EMPLOYEE";
// 	const existingRoleLabel = isEmployee ? "Employee" : "Dependent";
// 	const actionRoleLabel = isEmployee ? "Dependent" : "Employee";

// 	useEffect(() => {
// 		if (open) {
// 			setStep("conversion");
// 			setIsConverting(false);
// 		}
// 	}, [open]);

// 	const handleBackdropClick = (event: React.MouseEvent) => {
// 		event.stopPropagation();
// 	};

// 	const handleConfirm = () => {
// 		setIsConverting(true);

// 		setTimeout(() => {
// 			setStep("success");
// 			setIsConverting(false);
// 			if (onConfirm) {
// 				onConfirm();
// 			}
// 		}, 1200);
// 	};

// 	const handleClose = () => {
// 		onClose();
// 	};

// 	return (
// 		<Modal open={open} onClose={handleBackdropClick} closeAfterTransition>
// 			<Fade in={open} timeout={300}>
// 				<Box
// 					sx={{
// 						position: "absolute",
// 						top: "50%",
// 						left: "50%",
// 						transform: "translate(-50%, -50%)",
// 						width: 520,
// 						maxWidth: "90vw",
// 						maxHeight: "90vh",
// 						overflowY: "auto",
// 						bgcolor: "background.paper",
// 						borderRadius: "16px",
// 						boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
// 						animation: `${slideIn} 0.3s ease-out`,
// 						outline: "none"
// 					}}
// 					onClick={(e) => e.stopPropagation()}
// 				>
// 					{/* Close Button */}
// 					<IconButton
// 						onClick={handleClose}
// 						sx={{
// 							position: "absolute",
// 							top: 12,
// 							right: 12,
// 							color: "#64748b",
// 							zIndex: 10,
// 							"&:hover": { color: "#1e293b" }
// 						}}
// 					>
// 						<XIcon size={20} />
// 					</IconButton>

// 					{/* STEP 1: CONVERSION */}
// 					{step === "conversion" && (
// 						<Fade in={step === "conversion"} timeout={400}>
// 							<Box>
// 								{/* Header */}
// 								<Box
// 									sx={{
// 										backgroundColor: "#f8fafc",
// 										px: 3,
// 										py: 2,
// 										borderBottom: "1px solid #e2e8f0",
// 										display: "flex",
// 										alignItems: "center",
// 										justifyContent: "space-between"
// 									}}
// 								>
// 									<Box>
// 										<Typography variant="h6" sx={{ fontWeight: 700, color: "#1e293b" }}>
// 											Record Conversion
// 										</Typography>
// 									</Box>
// 									<Box
// 										sx={{
// 											backgroundColor: "#dbeafe",
// 											color: "#1e40af",
// 											px: 1.5,
// 											py: 0.5,
// 											borderRadius: "9999px",
// 											fontSize: "0.75rem",
// 											fontWeight: 500,
// 											marginRight: 8
// 										}}
// 									>
// 										Action Required
// 									</Box>
// 								</Box>

// 								<Box sx={{ p: 3 }}>
// 									{/* Alert */}
// 									<Box
// 										sx={{
// 											mb: 3,
// 											p: 2,
// 											backgroundColor: "#fffbeb",
// 											border: "1px solid #fcd34d",
// 											borderRadius: "8px",
// 											color: "#92400e"
// 										}}
// 									>
// 										<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
// 											<AlertTriangleIcon style={{ color: "#f59e0b", width: 20, height: 20 }} />
// 											<Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#92400e" }}>
// 												Role Conversion Detected
// 											</Typography>
// 										</Box>
// 										<Typography variant="body2" color="#92400e">
// 											This person currently exists as an <strong>{existingRoleLabel}</strong>. You
// 											are attempting to register them as a <strong>{actionRoleLabel}</strong>.
// 										</Typography>
// 									</Box>

// 									{/* Details Grid */}
// 									<Grid container spacing={3} sx={{ mb: 3 }}>
// 										<Grid item xs={6}>
// 											<Typography
// 												variant="caption"
// 												sx={{
// 													color: "#64748b",
// 													fontWeight: 600,
// 													textTransform: "uppercase",
// 													letterSpacing: "0.05em"
// 												}}
// 											>
// 												First Name
// 											</Typography>
// 											<Typography
// 												variant="body2"
// 												sx={{ fontWeight: 500, color: "#1e293b", mt: 0.5 }}
// 											>
// 												{first_name || "N/A"}
// 											</Typography>
// 										</Grid>
// 										<Grid item xs={6}>
// 											<Typography
// 												variant="caption"
// 												sx={{
// 													color: "#64748b",
// 													fontWeight: 600,
// 													textTransform: "uppercase",
// 													letterSpacing: "0.05em"
// 												}}
// 											>
// 												Last Name
// 											</Typography>
// 											<Typography
// 												variant="body2"
// 												sx={{ fontWeight: 500, color: "#1e293b", mt: 0.5 }}
// 											>
// 												{last_name || "N/A"}
// 											</Typography>
// 										</Grid>
// 										<Grid item xs={6}>
// 											<Typography
// 												variant="caption"
// 												sx={{
// 													color: "#64748b",
// 													fontWeight: 600,
// 													textTransform: "uppercase",
// 													letterSpacing: "0.05em"
// 												}}
// 											>
// 												Date of Birth
// 											</Typography>
// 											<Typography
// 												variant="body2"
// 												sx={{ fontWeight: 500, color: "#1e293b", mt: 0.5 }}
// 											>
// 												{date_of_birth || "N/A"}
// 											</Typography>
// 										</Grid>
// 										<Grid item xs={6}>
// 											<Typography
// 												variant="caption"
// 												sx={{
// 													color: "#64748b",
// 													fontWeight: 600,
// 													textTransform: "uppercase",
// 													letterSpacing: "0.05em"
// 												}}
// 											>
// 												Current Role
// 											</Typography>
// 											<Box
// 												sx={{
// 													mt: 0.5,
// 													display: "inline-flex",
// 													alignItems: "center",
// 													gap: 0.5,
// 													backgroundColor: "#dcfce7",
// 													color: "#166534",
// 													px: 1,
// 													py: 0.25,
// 													borderRadius: "4px",
// 													fontSize: "0.75rem",
// 													fontWeight: 600
// 												}}
// 											>
// 												<ShieldIcon style={{ width: 14, height: 14 }} />
// 												{existingRoleLabel}
// 											</Box>
// 										</Grid>

// 										{relationship && (
// 											<Grid item xs={12}>
// 												<Box sx={{ borderTop: "1px dashed #e2e8f0", pt: 2, mt: 1 }}>
// 													<Typography
// 														variant="caption"
// 														sx={{
// 															color: "#64748b",
// 															fontWeight: 600,
// 															textTransform: "uppercase",
// 															letterSpacing: "0.05em",
// 															mb: 1,
// 															display: "block"
// 														}}
// 													>
// 														Proposed Change
// 													</Typography>
// 													<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
// 														<ArrowRightIcon
// 															style={{ color: "#64748b", width: 20, height: 20 }}
// 														/>
// 														<Typography sx={{ fontWeight: 700, color: "#1e293b" }}>
// 															Convert to {actionRoleLabel}
// 														</Typography>
// 													</Box>
// 													<Typography
// 														variant="caption"
// 														color="text.secondary"
// 														sx={{ ml: 3.5 }}
// 													>
// 														Relationship: {relationship}
// 													</Typography>
// 												</Box>
// 											</Grid>
// 										)}
// 									</Grid>

// 									{/* Hidden Alt ID Display */}
// 									<Box
// 										sx={{
// 											display: "flex",
// 											alignItems: "center",
// 											justifyContent: "space-between",
// 											backgroundColor: "#f8fafc",
// 											borderRadius: "6px",
// 											px: 2,
// 											py: 1,
// 											mb: 3,
// 											border: "1px solid #e2e8f0"
// 										}}
// 									>
// 										<Typography
// 											variant="caption"
// 											sx={{
// 												fontFamily: "monospace",
// 												color: "#64748b",
// 												fontWeight: 500
// 											}}
// 										>
// 											SECURE_ID
// 										</Typography>
// 										<Typography
// 											variant="caption"
// 											sx={{
// 												fontFamily: "monospace",
// 												backgroundColor: "#ffffff",
// 												px: 1.5,
// 												py: 0.5,
// 												borderRadius: "4px",
// 												border: "1px solid #e2e8f0",
// 												color: "#374151",
// 												fontWeight: 600
// 											}}
// 										>
// 											{alt_id || "9921"}
// 										</Typography>
// 									</Box>

// 									<Divider sx={{ mb: 3 }} />

// 									{/* Actions */}
// 									<Box sx={{ display: "flex", gap: 2 }}>
// 										<Button
// 											fullWidth
// 											variant="outlined"
// 											onClick={handleClose}
// 											disabled={isConverting}
// 											sx={{
// 												py: 1.5,
// 												borderColor: "#e2e8f0",
// 												color: "#64748b",
// 												fontWeight: 600,
// 												textTransform: "none",
// 												borderRadius: "8px",
// 												"&:hover": {
// 													borderColor: "#cbd5e1",
// 													backgroundColor: "#f8fafc"
// 												}
// 											}}
// 										>
// 											Cancel
// 										</Button>
// 										<Button
// 											fullWidth
// 											variant="contained"
// 											onClick={handleConfirm}
// 											disabled={isConverting}
// 											sx={{
// 												py: 1.5,
// 												backgroundColor: "#4f46e5",
// 												fontWeight: 600,
// 												textTransform: "none",
// 												borderRadius: "8px",
// 												boxShadow: "0 4px 6px -1px rgba(79, 70, 229, 0.2)",
// 												"&:hover": { backgroundColor: "#4338ca" }
// 											}}
// 										>
// 											{isConverting ? "Processing..." : "Confirm"}
// 										</Button>
// 									</Box>
// 								</Box>
// 							</Box>
// 						</Fade>
// 					)}

// 					{/* STEP 2: SUCCESS */}
// 					{step === "success" && (
// 						<Fade in={step === "success"} timeout={500}>
// 							<Box sx={{ p: 4, textAlign: "center" }}>
// 								<Box
// 									sx={{
// 										width: 80,
// 										height: 80,
// 										borderRadius: "50%",
// 										backgroundColor: "#dcfce7",
// 										display: "flex",
// 										alignItems: "center",
// 										justifyContent: "center",
// 										margin: "0 auto 24px"
// 									}}
// 								>
// 									<CheckCircleIcon style={{ color: "#16a34a", width: 40, height: 40 }} />
// 								</Box>

// 								<Typography variant="h5" sx={{ fontWeight: 700, color: "#1e293b", mb: 1 }}>
// 									Conversion Successful
// 								</Typography>

// 								<Typography variant="body2" sx={{ color: "#64748b", mb: 4 }}>
// 									The record has been updated and the role has been converted successfully.
// 								</Typography>

// 								<Button
// 									fullWidth
// 									variant="contained"
// 									onClick={handleClose}
// 									sx={{
// 										py: 1.5,
// 										backgroundColor: "#1e293b",
// 										fontWeight: 600,
// 										textTransform: "none",
// 										borderRadius: "8px",
// 										"&:hover": { backgroundColor: "#0f172a" }
// 									}}
// 								>
// 									Close & Return
// 								</Button>
// 							</Box>
// 						</Fade>
// 					)}
// 				</Box>
// 			</Fade>
// 		</Modal>
// 	);
// };

// export default IdentityPersonConversionExistsModal;
/* eslint-disable arrow-parens */
import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, Button, Divider, IconButton, Fade } from "@mui/material";
import { Grid } from "@mui/material";
import { keyframes } from "@emotion/react";
import dateConverterUS from "../../../../../../../utils/date";

/* Icons as simple SVG components */
const ShieldIcon = (props: any) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
	</svg>
);

const XIcon = (props: any) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<line x1="18" y1="6" x2="6" y2="18" />
		<line x1="6" y1="6" x2="18" y2="18" />
	</svg>
);

const CheckCircleIcon = (props: any) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
		<polyline points="22 4 12 14.01 9 11.01" />
	</svg>
);

const AlertTriangleIcon = (props: any) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
		<line x1="12" y1="9" x2="12" y2="13" />
		<line x1="12" y1="17" x2="12.01" y2="17" />
	</svg>
);

const ArrowRightIcon = (props: any) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<line x1="5" y1="12" x2="19" y2="12" />
		<polyline points="12 5 19 12 12 19" />
	</svg>
);

const CreditCardIcon = (props: any) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
		<line x1="1" y1="10" x2="23" y2="10" />
	</svg>
);

const FingerprintIcon = (props: any) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 6" />
		<path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" />
		<path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" />
		<path d="M12 10a2 2 0 0 1 2 2c0 2.5-.5 4-1 6" />
		<path d="M8.65 22c.3-.6.8-2.1.9-4.02" />
		<path d="M14 13.12c0 2.38 0 4.38-1 7.88" />
		<path d="M2 16h.01" />
		<path d="M21.8 16c.2-2 .131-5.354 0-6" />
		<path d="M9 6.8a6 6 0 0 1 9 5.2c0 .37-.04.7-.1 1.01" />
	</svg>
);

/* Animation */
const slideIn = keyframes`
  0% {
    transform: translate(-50%, -60%);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
`;

interface IdentityConflictModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm?: () => void;
	memberData: any;
	isSSN?: boolean; // NEW: Determines if showing SSN or ALT ID
	idValue?: string; // NEW: The actual SSN or ALT ID value to display
}

type Step = "conversion" | "success";

const IdentityPersonConversionExistsModal: React.FC<IdentityConflictModalProps> = ({
	open,
	onClose,
	onConfirm,
	memberData,
	isSSN = false, // Default to ALT ID mode
	idValue = ""
}) => {
	const { first_name, last_name, date_of_birth, role, relationship, alt_id, SSN } = memberData || {};

	const [step, setStep] = useState<Step>("conversion");
	const [isConverting, setIsConverting] = useState(false);

	const isEmployee = role === "EMPLOYEE";
	const existingRoleLabel = isEmployee ? "Employee" : "Dependent";
	const actionRoleLabel = isEmployee ? "Dependent" : "Employee";

	// Determine what ID to display and how to label it
	const displayId = isSSN ? SSN || idValue || "N/A" : alt_id || idValue || "N/A";
	const idLabel = isSSN ? "SSN" : "ALT ID";
	const idIcon = isSSN ? FingerprintIcon : CreditCardIcon;
	const idColor = isSSN ? "#dc2626" : "#4f46e5"; // Red for SSN, Indigo for ALT ID
	const idBgColor = isSSN ? "#fef2f2" : "#eef2ff";

	useEffect(() => {
		if (open) {
			setStep("conversion");
			setIsConverting(false);
		}
	}, [open]);

	const handleBackdropClick = (event: React.MouseEvent) => {
		event.stopPropagation();
	};

	const handleConfirm = () => {
		setIsConverting(true);

		setTimeout(() => {
			setStep("success");
			setIsConverting(false);
			if (onConfirm) {
				onConfirm();
			}
		}, 1200);
	};

	const handleClose = () => {
		onClose();
	};

	return (
		<Modal open={open} onClose={handleBackdropClick} closeAfterTransition>
			<Fade in={open} timeout={300}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: 520,
						maxWidth: "90vw",
						maxHeight: "90vh",
						overflowY: "auto",
						bgcolor: "background.paper",
						borderRadius: "16px",
						boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
						animation: `${slideIn} 0.3s ease-out`,
						outline: "none"
					}}
					onClick={(e) => e.stopPropagation()}
				>
					{/* Close Button */}
					<IconButton
						onClick={handleClose}
						sx={{
							position: "absolute",
							top: 12,
							right: 12,
							color: "#64748b",
							zIndex: 10,
							"&:hover": { color: "#1e293b" }
						}}
					>
						<XIcon size={20} />
					</IconButton>

					{/* STEP 1: CONVERSION */}
					{step === "conversion" && (
						<Fade in={step === "conversion"} timeout={400}>
							<Box>
								{/* Header */}
								<Box
									sx={{
										backgroundColor: isSSN ? "#fef2f2" : "#f8fafc", // Light red for SSN
										px: 3,
										py: 2,
										borderBottom: `1px solid ${isSSN ? "#fecaca" : "#e2e8f0"}`,
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between"
									}}
								>
									<Box>
										<Typography variant="h6" sx={{ fontWeight: 700, color: "#1e293b" }}>
											{isSSN ? "SSN Conversion" : "Record Conversion"}
										</Typography>
									</Box>
									<Box
										sx={{
											backgroundColor: isSSN ? "#fee2e2" : "#dbeafe",
											color: isSSN ? "#991b1b" : "#1e40af",
											px: 1.5,
											py: 0.5,
											borderRadius: "9999px",
											fontSize: "0.75rem",
											fontWeight: 500,
											marginRight: 8
										}}
									>
										{isSSN ? "SSN Match" : "Action Required"}
									</Box>
								</Box>

								<Box sx={{ p: 3 }}>
									{/* Alert */}
									<Box
										sx={{
											mb: 3,
											p: 2,
											backgroundColor: isSSN ? "#fef2f2" : "#fffbeb",
											border: `1px solid ${isSSN ? "#fecaca" : "#fcd34d"}`,
											borderRadius: "8px",
											color: isSSN ? "#7f1d1d" : "#92400e"
										}}
									>
										<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
											<AlertTriangleIcon
												style={{
													color: isSSN ? "#dc2626" : "#f59e0b",
													width: 20,
													height: 20
												}}
											/>
											<Typography
												variant="subtitle2"
												sx={{
													fontWeight: 600,
													color: isSSN ? "#7f1d1d" : "#92400e"
												}}
											>
												{isSSN ? "SSN Conflict Detected" : "Role Conversion Detected"}
											</Typography>
										</Box>
										<Typography variant="body2" sx={{ color: isSSN ? "#7f1d1d" : "#92400e" }}>
											This person currently exists as an <strong>{existingRoleLabel}</strong> with
											this <strong>{idLabel}</strong>. You are attempting to register them as a
											<strong>{actionRoleLabel}</strong>.
										</Typography>
									</Box>

									{/* Details Grid */}
									<Grid container spacing={3} sx={{ mb: 3 }}>
										<Grid item xs={6}>
											<Typography
												variant="caption"
												sx={{
													color: "#64748b",
													fontWeight: 600,
													textTransform: "uppercase",
													letterSpacing: "0.05em"
												}}
											>
												First Name
											</Typography>
											<Typography
												variant="body2"
												sx={{ fontWeight: 500, color: "#1e293b", mt: 0.5 }}
											>
												{first_name || "N/A"}
											</Typography>
										</Grid>
										<Grid item xs={6}>
											<Typography
												variant="caption"
												sx={{
													color: "#64748b",
													fontWeight: 600,
													textTransform: "uppercase",
													letterSpacing: "0.05em"
												}}
											>
												Last Name
											</Typography>
											<Typography
												variant="body2"
												sx={{ fontWeight: 500, color: "#1e293b", mt: 0.5 }}
											>
												{last_name || "N/A"}
											</Typography>
										</Grid>
										<Grid item xs={6}>
											<Typography
												variant="caption"
												sx={{
													color: "#64748b",
													fontWeight: 600,
													textTransform: "uppercase",
													letterSpacing: "0.05em"
												}}
											>
												Date of Birth
											</Typography>
											<Typography
												variant="body2"
												sx={{ fontWeight: 500, color: "#1e293b", mt: 0.5 }}
											>
												{date_of_birth ? dateConverterUS(date_of_birth) : "N/A"}
											</Typography>
										</Grid>
										<Grid item xs={6}>
											<Typography
												variant="caption"
												sx={{
													color: "#64748b",
													fontWeight: 600,
													textTransform: "uppercase",
													letterSpacing: "0.05em"
												}}
											>
												Current Role
											</Typography>
											<Box
												sx={{
													mt: 0.5,
													display: "inline-flex",
													alignItems: "center",
													gap: 0.5,
													backgroundColor: "#dcfce7",
													color: "#166534",
													px: 1,
													py: 0.25,
													borderRadius: "4px",
													fontSize: "0.75rem",
													fontWeight: 600
												}}
											>
												<ShieldIcon style={{ width: 14, height: 14 }} />
												{existingRoleLabel}
											</Box>
										</Grid>

										{relationship && (
											<Grid item xs={12}>
												<Box sx={{ borderTop: "1px dashed #e2e8f0", pt: 2, mt: 1 }}>
													<Typography
														variant="caption"
														sx={{
															color: "#64748b",
															fontWeight: 600,
															textTransform: "uppercase",
															letterSpacing: "0.05em",
															mb: 1,
															display: "block"
														}}
													>
														Proposed Change
													</Typography>
													<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
														<ArrowRightIcon
															style={{ color: "#64748b", width: 20, height: 20 }}
														/>
														<Typography sx={{ fontWeight: 700, color: "#1e293b" }}>
															Convert to {actionRoleLabel}
														</Typography>
													</Box>
													<Typography
														variant="caption"
														color="text.secondary"
														sx={{ ml: 3.5 }}
													>
														Relationship: {relationship}
													</Typography>
												</Box>
											</Grid>
										)}
									</Grid>

									{/* Dynamic ID Display - Shows SSN or ALT ID */}
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											justifyContent: "space-between",
											backgroundColor: idBgColor,
											borderRadius: "8px",
											px: 2,
											py: 1.5,
											mb: 3,
											border: `1px solid ${isSSN ? "#fecaca" : "#c7d2fe"}`
										}}
									>
										<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
											{/* <idIcon
												style={{
													color: idColor,
													width: 20,
													height: 20
												}}
											/> */}
											<Typography
												variant="caption"
												sx={{
													color: "#64748b",
													fontWeight: 600,
													textTransform: "uppercase",
													letterSpacing: "0.05em"
												}}
											>
												Detected {idLabel}
											</Typography>
										</Box>
										<Typography
											variant="body2"
											sx={{
												fontFamily: "monospace",
												backgroundColor: "#ffffff",
												px: 1.5,
												py: 0.5,
												borderRadius: "6px",
												border: `1px solid ${isSSN ? "#fecaca" : "#c7d2fe"}`,
												color: idColor,
												fontWeight: 600,
												letterSpacing: "0.05em"
											}}
										>
											{displayId}
										</Typography>
									</Box>

									{/* Security Notice for SSN */}
									{isSSN && (
										<Box
											sx={{
												mb: 3,
												p: 2,
												backgroundColor: "#f0fdf4",
												border: "1px solid #86efac",
												borderRadius: "8px"
											}}
										>
											<Typography
												variant="caption"
												sx={{
													color: "#166534",
													display: "flex",
													alignItems: "center",
													gap: 1
												}}
											>
												<ShieldIcon style={{ width: 16, height: 16 }} />
												This SSN will be converted with security suffix for protection
											</Typography>
										</Box>
									)}

									<Divider sx={{ mb: 3 }} />

									{/* Actions */}
									<Box sx={{ display: "flex", gap: 2 }}>
										<Button
											fullWidth
											variant="outlined"
											onClick={handleClose}
											disabled={isConverting}
											sx={{
												py: 1.5,
												borderColor: "#e2e8f0",
												color: "#64748b",
												fontWeight: 600,
												textTransform: "none",
												borderRadius: "8px",
												"&:hover": {
													borderColor: "#cbd5e1",
													backgroundColor: "#f8fafc"
												}
											}}
										>
											Cancel
										</Button>
										<Button
											fullWidth
											variant="contained"
											onClick={handleConfirm}
											disabled={isConverting}
											sx={{
												py: 1.5,
												backgroundColor: isSSN ? "#dc2626" : "#4f46e5",
												fontWeight: 600,
												textTransform: "none",
												borderRadius: "8px",
												boxShadow: isSSN
													? "0 4px 6px -1px rgba(220, 38, 38, 0.2)"
													: "0 4px 6px -1px rgba(79, 70, 229, 0.2)",
												"&:hover": {
													backgroundColor: isSSN ? "#b91c1c" : "#4338ca"
												}
											}}
										>
											{isConverting ? "Processing..." : `Confirm ${idLabel} Conversion`}
										</Button>
									</Box>
								</Box>
							</Box>
						</Fade>
					)}

					{/* STEP 2: SUCCESS */}
					{step === "success" && (
						<Fade in={step === "success"} timeout={500}>
							<Box sx={{ p: 4, textAlign: "center" }}>
								<Box
									sx={{
										width: 80,
										height: 80,
										borderRadius: "50%",
										backgroundColor: isSSN ? "#fef2f2" : "#dcfce7",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										margin: "0 auto 24px"
									}}
								>
									<CheckCircleIcon
										style={{
											color: isSSN ? "#dc2626" : "#16a34a",
											width: 40,
											height: 40
										}}
									/>
								</Box>

								<Typography variant="h5" sx={{ fontWeight: 700, color: "#1e293b", mb: 1 }}>
									{isSSN ? "SSN Conversion Successful" : "Conversion Successful"}
								</Typography>

								<Typography variant="body2" sx={{ color: "#64748b", mb: 4 }}>
									{isSSN
										? `The ${idLabel} has been securely converted and the role has been updated.`
										: "The record has been updated and the role has been converted successfully."}
								</Typography>

								<Button
									fullWidth
									variant="contained"
									onClick={handleClose}
									sx={{
										py: 1.5,
										backgroundColor: isSSN ? "#dc2626" : "#1e293b",
										fontWeight: 600,
										textTransform: "none",
										borderRadius: "8px",
										"&:hover": {
											backgroundColor: isSSN ? "#b91c1c" : "#0f172a"
										}
									}}
								>
									Close & Return
								</Button>
							</Box>
						</Fade>
					)}
				</Box>
			</Fade>
		</Modal>
	);
};

export default IdentityPersonConversionExistsModal;
